/**
 * @author Ivan Toth.
 */
var paSiteBind = { editable: '=', tab: '@' };
var PaSiteNumController = (function () {
    function PaSiteNumController(topic) {
        this.topic = topic;
        this.comp = "paSiteNum";
        this.updateArray = [this.comp];
        return;
    }
    ;
    PaSiteNumController.prototype.addPaNum = function () {
        if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
            if (angular.isUndefined(this.topic.topic.paSiteNum) || !angular.isArray(this.topic.topic.paSiteNum)) {
                this.topic.topic.paSiteNum = [];
            }
            this.topic.setTempFromTopicPart(this.comp);
            if (angular.isDefined(this.paSiteNum) && this.paSiteNum !== '' && this.topic.temp.paSiteNum.indexOf(this.paSiteNum) < 0) {
                this.topic.temp.paSiteNum.push(this.paSiteNum);
                this.sendForUpdate('Added', this.paSiteNum);
            }
        }
    };
    PaSiteNumController.prototype.clearPaNum = function (item) {
        if (this.topic.updatePartialSocketStatus(this.updateArray, 'Updating')) {
            if (angular.isUndefined(this.topic.topic.paSiteNum) || !angular.isArray(this.topic.topic.paSiteNum)) {
                this.topic.topic.paSiteNum = [];
            }
            this.topic.setTempFromTopicPart(this.comp);
            var deleted = false;
            for (var count = this.topic.temp.paSiteNum.length - 1; count > -1; count--) {
                if (this.topic.temp.paSiteNum[count] === item) {
                    deleted = true;
                    this.topic.temp.paSiteNum.splice(count, 1);
                }
            }
            if (deleted) {
                this.sendForUpdate('Cleared', item);
            }
        }
    };
    PaSiteNumController.prototype.sendForUpdate = function (action, item) {
        var updData = {
            data: (_a = {},
                _a[this.comp] = {
                    add: true,
                    data: this.topic.temp.paSiteNum
                },
                _a['comments.' + this.tab] = {
                    push: true,
                    data: [{ comment: action + ' PA Site Num: ' + item }]
                },
                _a
            ),
            id: this.topic.topic._id,
            type: [this.comp, 'comments$' + this.tab]
        };
        this.topic.updateServerTopic('couchUpdate', updData, true);
        var _a;
    };
    PaSiteNumController.$inject = ['topic'];
    return PaSiteNumController;
}());
var PaSiteNumComponent = (function () {
    function PaSiteNumComponent() {
        this.bindings = paSiteBind;
        this.templateUrl = 'pa-site-num.html';
        this.controller = PaSiteNumController;
    }
    return PaSiteNumComponent;
}());
angular
    .module('application')
    .component('paSiteNumSection', new PaSiteNumComponent());

//# sourceMappingURL=pa-site-num.components.js.map
